<template>
  <div>
    <!-- マイページコンテンツ -->
    <router-view></router-view>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import LoggedInPageBase from 'extends/LoggedInPageBase.vue'

  export default {
    name:"Payment",
    extends:LoggedInPageBase,
    components: {
    },
    data () {
      return {
      }
    },
    watch: {
      '$route' (to, from) {
      }
    },
    mounted(){
    },
    methods:{

    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Payment.vue?02275321